export default __webpack_public_path__ + "static/media/partner-brendan.0948e283.jpg";